import React, { useState } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import { withRouter, useHistory, NavLink } from 'react-router-dom';
import { vehicleNumberDisplay,getDateInStringDDMMMYYYY } from '../../../../utils/utils';
import { 
  TRIP_STATUS,
  TRIP_DISPLAY_STATUS
 } from '../../../../store/constants';
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import StepContent from "@material-ui/core/StepContent";
import StepConnector from "@material-ui/core/StepConnector";
import clsx from 'clsx';
import { Box } from '@material-ui/core';
 //Icons
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import FiberManualRecordIcon from "@material-ui/icons/FiberManualRecord";
const useStyles = makeStyles((theme) => ({
  card: {
    width: '100%',
    //height: 84,
    padding: "16px 24px",
    display: 'flex',
    alignItems: 'center',
    backgroundColor:'#fff',
    boxShadow:'none'
  },
  circleIcon: {
    borderRadius: "50%",
    backgroundColor: "#c7c7c7",
    fontSize: 24,
    color: "#c7c7c7",
  },
  completedIcon: {
    //backgroundColor: "#008556",
    color: "#008556",
    zIndex: 1,
    borderRadius: "50%",
    fontSize: 24,
  },
  stepIconRoot: {
    color: "#eaeaf0",
    display: "flex",
    //height: 22,
    alignItems: "center",
  },
  activeStepIcon: {
    color: "#784af4",
  },
  tripStepper: {
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop:0,
    paddingBottom:0,
    width:'100%'
  },
  dateLabel:{
      fontSize:12,
      color:'#636872'
  },
  label:{
    fontSize:14,
    color:'#0b1323',
    fontWeight:600
  },
  completedStep:{
    '& .custom-step-content':{
      borderLeft:'2px solid #008556 !important'
    },
    '& .MuiStepLabel-root':{
      "&:before": {
        background: "#008556 !important"
      },
      "&:after": {
        background: "#008556 !important"
      }
    }
  }
}));
const TripTimelineConnector = withStyles({
  alternativeLabel: {
    top: 10,
    left: "calc(-50% + 9px)",
    right: "calc(50% + 9px)",
    //fontSize: 12,
  },
  active: {
    "& $line": {
      borderColor: "#c7c7c7",
    },
  },
  completed: {
    "& $line": {
      borderColor: "#008556",
    },
  },
  line: {
    borderColor: "#c7c7c7",
    borderTopWidth: 4,
    borderRadius: 1,
  }
})(StepConnector);
function TripStepIcon(props) {
  const classes = useStyles();
  const { active, completed } = props;
  return (
    <div
      className={clsx(classes.stepIconRoot, {
        [classes.activeStepIcon]: active,
      })}
    >
      {completed ? (
        <CheckCircleIcon className={classes.completedIcon} />
      ) : (
          <FiberManualRecordIcon className={classes.circleIcon} />
        )}
    </div>
  );
}
const JourneyTripTimeline = (props) => {
  const {trip} = props;
  const classes = useStyles();
  let history = useHistory();
  const getEventDate = (eventName) => {
    if (trip && trip.tripEvents) {
      if (eventName === 'Settled') {
        eventName = 'PAYMENT_RECEIVED'
      }
      eventName = eventName.replace(' ', '_');
      const event = trip.tripEvents.filter((e) => {
        return (e["event"].toLowerCase() == eventName.toLowerCase())
      })[0]
      if (event && event["eventDate"]) {
        return getDateInStringDDMMMYYYY(event["eventDate"]);
      }
    }
    return null;
  }
  return (
    <>
      <Paper component='div' className={classes.card} >
      <Stepper
        alternativeLabel
        activeStep={TRIP_STATUS[trip.status]}
        connector={<TripTimelineConnector className={classes.connector} />}
        className={classes.tripStepper}
      >
        {TRIP_DISPLAY_STATUS.map((label) => (
          <Step key={label} classes={{root:classes.stepRoot,completed:classes.completedStep}}>
            <StepLabel
              classes={{
                //label:classes.tripVerticalStepperLabel,
                //vertical: classes.verticalLabel,
                completed:classes.completedStep
              }}
              StepIconComponent={TripStepIcon}
            >
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center">
              <span className={classes.label}>{label}</span>
              <span className={classes.dateLabel}>{getEventDate(label)}</span>
            </Box>
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      </Paper>
    </>
  );
}
export default JourneyTripTimeline;